
import {
  StockAlertDto,
  CreateStockAlertDto,
  UpdateStockAlertDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type StockAlertsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
}

class StockAlertService extends BaseCrudService<
  StockAlertDto,
  CreateStockAlertDto,
  UpdateStockAlertDto,
  StockAlertsFilters
> {
  constructor() {
    super('stock-alert', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const stockAlertService = new StockAlertService()
